<template>
  <div>
    <validation-observer ref="collectionFeeRules">
      <b-form>
        <b-row>
          <b-col
            sm="12"
          >
            <validation-provider
              #default="{ errors }"
              name="Collection fee"
              rules="required|collection"
            >
              <b-form-group
                :label="$t('DEBTIA_COLLECTION_FEE')"
                label-for="collectionFee"
              >
                <b-form-input
                  v-model="collectionFee"
                  type="number"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Fee"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            cols="12"
          >
            <b-button
              variant="primary"
              type="submit"
              class="addAwaitBtn"
              @click.prevent="validationCollectionFeeForm"
            >
              {{ $t('DEBTIA_SUBMIT') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup,
  BFormInput,
  BButton,
  BForm,
  BRow,
  BCol,
  // BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import { required, collection } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    // BCardCode,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    // BInputGroup,
    BFormInput,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      collection,
      collectionFee: 0,
      validateFee: true,
    }
  },
  created() {
  },
  methods: {
    async validationCollectionFeeForm() {
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 13,
        module_order: 1,
        collection_fee: Number(this.collectionFee),
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      await this.$refs.collectionFeeRules.validate().then(success => {
        if (success) {
          axios.post('/process/module/collection-fee-validation', {
            process_id: Number(processID),
            fee_amount: Number(this.collectionFee),
          }).then(() => {
            this.validateFee = true
            const url = '/process/module/add'
            axios.post(url, dataObj).then(response => {
              if (response.status === 200) {
                this.collectionFee = 0
                const returnObj = {
                  parentID: this.conditionObject.parentID,
                  depend: dataObj.depends_on,
                }
                returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
                this.$emit('closeCollectionFeeModal', returnObj)
              }
            }).catch(e => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Error',
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: e.response.data.message[0],
                },
              })
            })
          }).catch(e => {
            this.validateFee = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: e.response.data.message,
              },
            })
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .addAwaitBtn {
    width: 100%;
  }
</style>
